import { Box, Button, Label, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField, useFormikContext } from 'formik';
import { SelectFieldProvider } from './SelectFieldContext';
import { Selected } from './Selected';
import { ErrorMessage } from '../ErrorMessage';
export function Root(props) {
    const { name, label, placeholder, children, useTriggerWidth = false, selectedWrapper, size = 'medium', stretch = false, } = props;
    const { isSubmitting } = useFormikContext();
    const [, meta] = useField(name);
    const validationError = Boolean(meta.touched && meta.error);
    return (<SelectFieldProvider name={name}>
      <Box flexDirection="column" gap="xs" width={stretch ? '100%' : undefined}>
        {label && <Label $invalid={validationError}>{label}</Label>}
        <Menu.Root useTriggerWidth={useTriggerWidth} target={<Button $stretch type="button" appearance="secondary" size={size} disabled={isSubmitting} style={{ justifyContent: 'space-between' }}>
              <Selected placeholder={placeholder} render={selectedWrapper}>
                {children}
              </Selected>
              <Falcon icon="chevron-down"/>
            </Button>}>
          {children}
        </Menu.Root>
        <ErrorMessage name={name}/>
      </Box>
    </SelectFieldProvider>);
}
